export default __webpack_public_path__ + "static/media/clarity_note-edit-line.a4efc71a.svg";